import React, { useMemo, useState } from "react";
import {
  Bold,
  CircleContainer,
  Circle,
  CaseStudyContainer,
  CaseStudyInnerContainer,
  CaseStudyImageParagraphContainer,
  CaseStudyImageParagraph,
  PillsGroup,
  Pill,
  CaseStudyParagraph,
  CaseStudyParagraphHeaderAlt,
  CaseStudyParagraphHeader,
  CaseStudyTextContainer,
  CaseStudyText,
  CaseStudyImageContainer,
  CaseStudyImage,
  StatsContainer,
  StatItem,
  StatNumber,
  StatLabel,
  ProjectsContainer,
  CaseStudyHeader,
  ProjectSummaryContainer,
} from "./CaseStudy.styled";
import { Trans, useTranslation } from "react-i18next";
import { Highlight } from "components/Hightlight/Hightlight.style";
import { ReactComponent as ButtonIcon } from "assets/images/svg/arrow-up-right.svg";
import useDevice from "hooks/useDevice";
import { caseStudies } from "constants/caseStudies";
import { useNavigate } from "react-router-dom";

const CaseStudy = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile } = useDevice();
  const filterKeys = t("ourWorkPage.challengeToSolution.filters", {
    returnObjects: true,
  });
  const filterKeyList = Object.keys(filterKeys);
  const [selectedFilter, setSelectedFilter] = useState(
    "ourWorkPage.challengeToSolution.filters.0"
  );

  const projects = caseStudies;

  const filteredProjects = useMemo(() => {
    if (t(selectedFilter) === t("ourWorkPage.challengeToSolution.filters.0"))
      return projects;
    return projects.filter(
      (project) => t(project.industry) === t(selectedFilter)
    );
  }, [selectedFilter, projects]);

  return (
    <ProjectsContainer>
      <PillsGroup>
        {filterKeyList.map((key) => {
          const fullKey = `ourWorkPage.challengeToSolution.filters.${key}`;
          return (
            <Pill
              key={fullKey}
              onClick={() => setSelectedFilter(fullKey)}
              $isFirst={selectedFilter === fullKey}
              $isSelected={selectedFilter === fullKey}
              $isFilter={true}
            >
              <Trans i18nKey={fullKey} />
            </Pill>
          );
        })}
      </PillsGroup>
      <CaseStudyContainer>
        {filteredProjects?.map((project, index) => {
          return (
            <CaseStudyInnerContainer
              key={index}
              onClick={() => {
                navigate(project.link);
              }}
              isMobile={isMobile}
              $isInHouseProject={project.isInHouseProject}
              $highlightColor={
                project.isInHouseProject ? "thertiary" : "secondaryOpaque"
              }
            >
              <CaseStudyImageParagraphContainer>
                <CaseStudyImageParagraph>
                  <CaseStudyParagraph>
                    <Trans
                      i18nKey={project.header}
                      components={{
                        3: (
                          <CaseStudyHeader
                            $radius={project.radius}
                            $imgWidth={project.width}
                          />
                        ),
                        2: (
                          <CaseStudyParagraphHeaderAlt
                            $radius={project.radius}
                            $imgWidth={project.width}
                            $padding={project.smallPaddingBigger}
                          />
                        ),
                        1: (
                          <CaseStudyParagraphHeader
                            $radius={project.radius}
                            $imgWidth={project.width}
                          />
                        ),
                        0: <Bold $biggerPadding={project.biggerPadding} />,
                      }}
                    />
                  </CaseStudyParagraph>
                  <CaseStudyImageContainer $options={project.imageOptions}>
                    <CaseStudyImage
                      src={project.image}
                      $imgWidth={project.width || "100%"}
                    />
                  </CaseStudyImageContainer>
                </CaseStudyImageParagraph>
              </CaseStudyImageParagraphContainer>
              <CaseStudyTextContainer>
                <CaseStudyText>
                  <Trans
                    i18nKey={project.text}
                    components={[
                      <Highlight
                        key={0}
                        isText
                        IsBold
                        color={
                          project.isInHouseProject
                            ? "thertiary"
                            : "secondaryOpaque"
                        }
                      />,
                    ]}
                  />
                </CaseStudyText>
                <ProjectSummaryContainer>
                  <StatsContainer>
                    {project.users_number && (
                      <StatItem>
                        <StatNumber>
                          <Trans i18nKey={project.users_number} />
                        </StatNumber>
                        <StatLabel>
                          <Trans i18nKey={project.users_label} />
                        </StatLabel>
                      </StatItem>
                    )}
                    {project.rate_number && (
                      <StatItem>
                        <StatNumber>
                          <Trans i18nKey={project.rate_number} />
                        </StatNumber>
                        <StatLabel>
                          <Trans i18nKey={project.rate_label} />
                        </StatLabel>
                      </StatItem>
                    )}
                    {project.yearsInUse_number && (
                      <StatItem>
                        <StatNumber>
                          <Trans i18nKey={project.yearsInUse_number} />
                        </StatNumber>
                        <StatLabel>
                          <Trans i18nKey={project.yearsInUse_label} />
                        </StatLabel>
                      </StatItem>
                    )}
                  </StatsContainer>
                  <CircleContainer>
                    <PillsGroup>
                      <Pill $isFirst $inHouseProject={project.isInHouseProject}>
                        <Trans i18nKey={project.category} />
                      </Pill>
                      <Pill>
                        <Trans i18nKey={project.industry} />
                      </Pill>
                      <Pill>
                        <Trans i18nKey={project.location} />
                      </Pill>
                    </PillsGroup>
                    <Circle href={project.link}>
                      <ButtonIcon />
                    </Circle>
                  </CircleContainer>
                </ProjectSummaryContainer>
              </CaseStudyTextContainer>
            </CaseStudyInnerContainer>
          );
        })}
      </CaseStudyContainer>
    </ProjectsContainer>
  );
};
export default CaseStudy;
